import * as React from "react";

import { Box, makeStyles, Theme, Typography } from "@material-ui/core";
import { useLocation } from "react-router-dom";

import { useBranding } from "client/hooks/useBranding";
import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";

import { PrivacyPolicyLink } from "./PrivacyPolicyLink";

const useStyles = makeStyles((theme: Theme) => {
  const { gray40 } = useNormalizedBrandPaletteValues(theme);

  return {
    root: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      position: "fixed",
      bottom: theme.spacing(1),
      right: theme.spacing(1),
      [theme.breakpoints.down("sm")]: {
        marginTop: theme.spacing(3),
        flexDirection: "column",
        position: "revert",
        bottom: 0,
        right: 0,
      },
    },
    linksWrapper: {
      display: "flex",
      [theme.breakpoints.down("sm")]: {
        fontSize: `${12 / 16}rem`,
        marginBottom: theme.spacing(1),
      },
    },
    copyright: {
      marginRight: theme.spacing(2),
      color: gray40,
      fontSize: `${14 / 16}rem`,
      [theme.breakpoints.down("sm")]: {
        marginRight: 0,
      },
    },
  };
});

export const MerchantLinks: React.FC = () => {
  const { brandTitle } = useBranding();
  const classes = useStyles();
  const location = useLocation();

  if (!/onboarding|status/i.test(location.pathname)) {
    return null;
  }

  const currentYear = new Date().getFullYear();
  return (
    <Box className={classes.root}>
      <Typography variant="body2" className={classes.copyright}>
        © {currentYear} {brandTitle}
      </Typography>
      <Box className={classes.linksWrapper}>
        <PrivacyPolicyLink />
      </Box>
    </Box>
  );
};
